import { render, staticRenderFns } from "./OnboardingSteps.vue?vue&type=template&id=05cdb119&scoped=true&"
import script from "./OnboardingSteps.vue?vue&type=script&lang=js&"
export * from "./OnboardingSteps.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSteps.vue?vue&type=style&index=0&id=05cdb119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdb119",
  null
  
)

export default component.exports